import Layout from '../../components/layout/Layout'
import TiffinPlanTable from '../../elements/tables/plans/TiffinPlanTable'

export default function TiffinPlan() {
  return (
    <div>
      <Layout>
        <TiffinPlanTable />
      </Layout>
    </div>
  )
}
